export const getLabelByField = field => (
  heatmapFields.find(f => f.field === field) ? heatmapFields.find(f => f.field === field).label : field
);

export const heatmapFields = [
  { label: "Heatmap", field: "Name", isVisible: true, isDefault: true },
  { label: "Heatmap Owner", field: "Owner_First_Name__c", isVisible: true },
  { label: "Owner", field: "OwnerId" }, // not used, but kept
  { label: "Account Name", field: "Related_Account__r.Name", isVisible: true, isDefault: true },
  { label: "Contact", field: "Contact__r.Name", isVisible: true, isDefault: true },
  { label: "Priority", field: "Priority__c", isVisible: true },
  { label: "Preferred Channel", field: "Preferred_Channel__c", isVisible: true },
  { label: "Intro By", field: "Intro_By__r.Name", isVisible: true },
  { label: "Intro By", field: "Intro_By__c" }, // raw version
  { label: "Engagement Status", field: "Engagement_Status__c", isVisible: true, isDefault: true },
  { label: "Relationship Strength", field: "Relationship_Strength__c", isVisible: true },
  { label: "Campaign", field: "Campaign__c", isVisible: true },
  { label: "Description", field: "Description__c", isVisible: true },
  { label: "Target Date", field: "Target_Date__c", isVisible: true, isDefault: true },
  { label: "Touch Base Date", field: "Touch_Base_Date__c", isVisible: true, isDefault: true },
  { label: "Communication Interval", field: "Communication_Interval__c", isVisible: true },
  { label: "Touchbase Timing", field: "Touchbase_Timing__c", isVisible: true },
  { label: "Last Touchbase", field: "Last_Touchbase__c", isVisible: true },
  { label: "Next Touchbase", field: "Next_Touchbase__c", isVisible: true },
  { label: "Next Step", field: "Next_Step__c", isVisible: true },
  { label: "Next Step Date", field: "Next_Step_Date__c", isVisible: true },
  { label: "Next Step POC", field: "Next_Step_POC__r.Name", isVisible: true },
  { label: "Next Step POC", field: "Next_Step_POC__c" },
  { label: "Next Step Owner", field: "Next_Step_Owner__r.Name", isVisible: true },
  { label: "Next Step Owner", field: "Next_Step_Owner__c" },
  { label: "Account Name (Contact)", field: "Account_Name__c", isVisible: true, isDefault: true },
  { label: "Title", field: "Title__c", isVisible: true },
  { label: "Role Category", field: "Role_Category__c", isVisible: true, isDefault: true },
  { label: "Segment", field: "Segment__c", isVisible: true },
  { label: "Region", field: "Region__c", isVisible: true, isDefault: true },
  { label: "Subsidary", field: "Subsidary__c", isVisible: true },
  { label: "US District", field: "US_District__c", isVisible: true },
  { label: "Area of Interest", field: "Area_of_Interest__c", isVisible: true },
  { label: "Industry of Focus", field: "Industry_of_Focus_c__c", isVisible: true },
  { label: "Email", field: "Email__c", isVisible: true },
  { label: "Reports To", field: "Reports_To__c", isVisible: true },
  { label: "Contact Classification", field: "Contact_Classification_1__c", isVisible: true, isDefault: true },
  { label: "Created By", field: "CreatedBy.Name", isVisible: true },
  { label: "Last Modified By", field: "LastModifiedBy.Name", isVisible: true },
  { label: "Request Reason", field: "Request_Reason__c", isVisible: true, isDefault: true },
  { label: "Request Reason (Rel)", field: "Request_Reason__r.Name" }
];
export const getDefaultFields = () => heatmapFields.filter(f => f.isDefault);
export const getDisplayFields = (isDefault=false, keys = null) => {
  const visibleFields = heatmapFields
  .filter(f => f.isVisible)
  .filter(f => isDefault ? f.isDefault : true);

  if (!keys||keys.length==0) return visibleFields;

  return keys
    .map(key => visibleFields.find(f => f.field === key))
    .filter(Boolean);
};
const dashboardReportFileds = [
  'Id',
  'StageName',
  'Name',
  'Leading_Cloud__c',
  'Activity_Type__c',
  'Cloud_POC__r.Name',
  'End_Customer_Region__c',
  'End_Customer_HQ__c',
  'Last_Stage_Change_Date_internal__c',
  'ISV_Opportunity_Owner__r.Name',
  'ISV_Opportunity_Stage__c',
  'Customer_Status__c',
  'Priority__c',
  'Last_Meeting_Date__c',
  'NextStep',
  'Next_Step_Date__c',
  'Next_Step_Owner__r.Name',
  'Opportunity_Heat__c',
  'Is_on_ACE_PSC__c',
  'ACE_Partner_Center_Status__c',
  'Is_for_Marketplace__c'
];
export const getDashboardDisplayFields = (isDefault = false, keys = null,) => {
  const visibleDashboardFields = dashboardReportFileds
    .map(field => heatmapFields.find(f => f.field === field))
    .filter(Boolean)
    .filter(f => isDefault ? f.isDefault : true)
    .map(f => ({ ...f, isVisible: true }));

  if (!keys||keys.length==0) return visibleDashboardFields;

  return keys
    .map(key => visibleDashboardFields.find(f => f.field === key))
    .filter(Boolean);
};
